import { ICountry } from '../../../../domain/addresses/interfaces';

/**
 * get first country index from the filtered counties list
 */
export const getInitialSelectedCountryId = (filteredCountries: ICountry[]) => {
    return filteredCountries && filteredCountries.length > 0 ? filteredCountries[0].countryID : 0;
};
